<app-page-title
  [icon]="'user'"
  pageTitle="{{ 'common.profile' | translate }}"
  [showBack]="false"
></app-page-title>

<!-- <app-user-availability [user]="user"></app-user-availability> -->

<section [hidden]="!user || !profileForm$">
  <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab value="0">{{ 'user.tabs.user-basic-info' | translate }}</p-tab>
      <p-tab value="1">{{
        'user.tabs.availability-profile' | translate
      }}</p-tab>
      @if (filterType === 'service') {
        <p-tab value="2" *appVisibleOnly="['read_appointment_period']">{{ 'user.tabs.appointment-period' | translate }}</p-tab>
      }
      <p-tab value="3">{{ 'user.tabs.diagnosis-profile' | translate }}</p-tab>
    </p-tablist>
    <p-tabpanel value="0">
      @if (profileForm$) {
        <section>
          <app-dynamic-form
            [form]="profileForm$ | async"
            (submitForm)="submit($event)"
          ></app-dynamic-form>
        </section>
      }
    </p-tabpanel>

    <p-tabpanel value="1">
      <section>
        <app-user-availability [user]="user!"></app-user-availability>
      </section>
    </p-tabpanel>

    @if (filterType === 'service') {
      <p-tabpanel value="2" *appVisibleOnly="['read_appointment_period']">
        <section class="mt-2">
          <app-appointment-period-schedule
            [user]="user!"
          ></app-appointment-period-schedule>
        </section>
      </p-tabpanel>
    }

    <p-tabpanel value="3">
      <section>
        <div
          class="p-mb-3"
          style="display: flex; align-items: center; gap: 1rem"
        >
          <span>{{
            'healthrecords.healthrecord.ICD10-display-language' | translate
          }}</span>
          <p-selectButton
            [options]="displayLanguageOptions"
            [(ngModel)]="displayLanguage"
            [optionLabel]="'label'"
            [optionValue]="'value'"
          ></p-selectButton>
        </div>
        <h4>{{ 'healthrecords.healthrecord.ICD10-all-codes' | translate }}</h4>
        <div class="p-mb-3">
          <span class="p-input-icon-left" style="width: 100%">
            <i class="pi pi-search"></i>
            <input
              type="text"
              pInputText
              [(ngModel)]="allDiagnosisSearchTerm"
              (input)="onAllDiagnosisSearch($event)"
              [placeholder]="
                'healthrecords.healthrecord.ICD10-search-placeholder'
                  | translate
              "
              style="width: 100%"
            />
          </span>
          @if (loading) {
            <i class="pi pi-spin pi-spinner" style="margin-left: 8px"></i>
          }
        </div>
        <p-table
          [value]="diagnosis"
          selectionMode="single"
          dataKey="codeId"
          (onRowSelect)="onRowSelect($event)"
          [paginator]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{{
            'healthrecords.healthrecord.ICD10-codes-total-records' | translate
          }}"
          [rowsPerPageOptions]="[10, 20, 50, 100]"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="codeId">
                {{ 'healthrecords.healthrecord.ICD10-code' | translate }}
                <p-sortIcon field="codeId"></p-sortIcon>
              </th>
              @if (showShortNameColumn()) {
                <th pSortableColumn="shortName">
                  {{
                    'healthrecords.healthrecord.ICD10-short-name' | translate
                  }}
                  <p-sortIcon field="shortName"></p-sortIcon>
                </th>
              }
              <th pSortableColumn="longName">
                {{ nameColumnHeaderKey() | translate }}
                <p-sortIcon field="longName"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-diagnosis>
            <tr [pSelectableRow]="diagnosis">
              <td>{{ diagnosis.codeId }}</td>
              @if (showShortNameColumn()) {
                <td>{{ diagnosis.shortName }}</td>
              }
              <td>{{ longNameFor(diagnosis) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td
                [attr.colspan]="showShortNameColumn() ? 3 : 2"
                style="text-align: center"
              >
                @if (allDiagnosisSearchTerm) {
                  {{
                    'healthrecords.healthrecord.ICD10-no-results' | translate
                  }}
                } @else {
                  {{
                    'healthrecords.healthrecord.ICD10-start-typing' | translate
                  }}
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </section>
      <section>
        <h4>{{ 'healthrecords.healthrecord.ICD10-own-codes' | translate }}</h4>
        <div class="p-mb-3">
          <span class="p-input-icon-left" style="width: 100%">
            <i class="pi pi-search"></i>
            <input
              type="text"
              pInputText
              [(ngModel)]="userDiagnosisSearchTerm"
              (input)="onUserDiagnosisSearch($event)"
              [placeholder]="
                'healthrecords.healthrecord.ICD10-search-placeholder'
                  | translate
              "
              style="width: 100%"
            />
          </span>
          @if (userDiagnosisLoading) {
            <i class="pi pi-spin pi-spinner" style="margin-left: 8px"></i>
          }
        </div>
        <p-table
          [value]="userDiagnosis"
          [(selection)]="selectedProducts"
          [rowHover]="true"
          dataKey="id"
          [paginator]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{{
            'healthrecords.healthrecord.ICD10-codes-total-records' | translate
          }}"
          [rowsPerPageOptions]="[10, 20, 50, 100]"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 4rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th></th>
              <th pSortableColumn="codeId">
                {{ 'healthrecords.healthrecord.ICD10-code' | translate }}
                <p-sortIcon field="codeId"></p-sortIcon>
              </th>
              @if (showShortNameColumn()) {
                <th pSortableColumn="shortName">
                  {{
                    'healthrecords.healthrecord.ICD10-short-name' | translate
                  }}
                  <p-sortIcon field="shortName"></p-sortIcon>
                </th>
              }
              <th pSortableColumn="longName">
                {{ nameColumnHeaderKey() | translate }}
                <p-sortIcon field="longName"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th></th>
              <th>
                <button
                  pButton
                  [type]="'button'"
                  [className]="'p-button-primary'"
                  (click)="deleteSelectedProducts()"
                  [disabled]="!selectedProducts || !selectedProducts.length"
                >
                  {{ 'common.button.delete' | translate }}
                </button>
              </th>
              <th></th>
              @if (showShortNameColumn()) {
                <th></th>
              }
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-userDiagnosis>
            <tr
              [pSelectableRow]="userDiagnosis"
              [class.icd10-deprecated]="isDeprecated(userDiagnosis)"
            >
              <td>
                <p-tableCheckbox [value]="userDiagnosis"></p-tableCheckbox>
              </td>
              <td>
                @if (isDeprecated(userDiagnosis)) {
                  <i
                    class="pi pi-exclamation-triangle"
                    style="color: var(--red-500)"
                    [pTooltip]="
                      (userDiagnosis.leafNode !== 'T'
                        ? 'healthrecords.healthrecord.ICD10-group-code'
                        : 'healthrecords.healthrecord.ICD10-expired-code'
                      ) | translate
                    "
                  ></i>
                }
              </td>
              <td>{{ userDiagnosis.codeId }}</td>
              @if (showShortNameColumn()) {
                <td>{{ userDiagnosis.shortName }}</td>
              }
              <td>{{ longNameFor(userDiagnosis) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td
                [attr.colspan]="showShortNameColumn() ? 5 : 4"
                style="text-align: center"
              >
                @if (userDiagnosisSearchTerm) {
                  {{
                    'healthrecords.healthrecord.ICD10-no-results' | translate
                  }}
                } @else {
                  {{
                    'healthrecords.healthrecord.ICD10-no-own-codes' | translate
                  }}
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </section>
    </p-tabpanel>
  </p-tabs>
</section>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
